/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
 import React from 'react';
 import { t } from '@superset-ui/core';
 import { Moment } from 'moment';
 import { Col, Row } from 'src/common/components';
 import { DatePicker } from 'src/components/DatePicker';
 import { InfoTooltipWithTrigger } from '@superset-ui/chart-controls';
 import {
   MOMENT_FORMAT,
   customTimeRangeDecode,
   customTimeRangeEncode,
   dttmToMoment,
 } from 'src/explore/components/controls/DateFilterControl/utils';
 import {
   CustomRangeKey,
   FrameComponentProps,
 } from 'src/explore/components/controls/DateFilterControl/types';
 
 export function SpecificDateFrame(props: FrameComponentProps) {
   const { customRange, matchedFlag } = customTimeRangeDecode(props.value);
   if (!matchedFlag) {
     props.onChange(customTimeRangeEncode(customRange));
   }
   const {
     sinceDatetime,
   } = { ...customRange };
   function onChange(control: CustomRangeKey, value: Moment) {
     props.onChange(
       customTimeRangeEncode({
         ...customRange,
         sinceMode: 'specific',
         untilMode: 'specific',
         [control]: value.format(MOMENT_FORMAT),
         untilDatetime: value.format(MOMENT_FORMAT),
       }),
     );
   }
   return (
     <div data-test="specific-date-frame">
       <div className="section-title">{t('Configure specific date')}</div>
       <Row gutter={24}>
         <Col span={24}>
           <div className="control-label">
             {t('Date')}{' '}
             <InfoTooltipWithTrigger
               tooltip={t('Specific Date')}
               placement="right"
             />
           </div>
            <Row>
                <DatePicker
                    showTime
                    defaultValue={dttmToMoment(sinceDatetime)}
                    onChange={(datetime: Moment) =>{
                    onChange('sinceDatetime', datetime)}
                    }
                    allowClear={false}
                />
            </Row>
         </Col>
       </Row>
     </div>
   );
 }
 